import { BusinessUnitField } from "./BusinessUnitField";
import { ButtonField } from "./ButtonField";
import { CalculatedField } from "./CalculatedField";
import { CheckboxField } from "./CheckboxField";
import { CheckboxGroupField } from "./CheckboxGroupField";
import { ContinuousCommentsField } from "./ContinuousCommentsField";
import { DateField } from "./DateField";
import { DateTimeField } from "./DateTimeField";
import { FileUploadField } from "./FileUploadField";
import { GalleryField } from "./GalleryField";
import { ImageLabelField } from "./ImageLabelField";
import { GroupPickerField } from "./GroupPickerField";
import { HyperlinkField } from "./HyperlinkField";
import { IndexField } from "./IndexField";
import { LabelField } from "./LabelField";
import { ListField } from "./ListField";
import { NumericField } from "./NumericField";
import { PeoplePickerField } from "./PeoplePickerField";
import { RadioButtonField } from "./RadioButtonField";
import { SignatureField } from "./SignatureField";
import { TableField } from "./TableField";
import { TableIndexField } from "./TableIndexField";
import { TextAreaField } from "./TextAreaField";
import { TextField } from "./TextField";
import { TimeField } from "./TimeField";

const fieldComponents = {
  TextField: TextField,
  List: ListField,
  TextArea: TextAreaField,
  Numeric: NumericField,
  Label: LabelField,
  RadioButton: RadioButtonField,
  PeoplePicker: PeoplePickerField,
  GroupPicker: GroupPickerField,
  BusinessUnit: BusinessUnitField,
  Date: DateField,
  Checkbox: CheckboxField,
  CheckboxGroup: CheckboxGroupField,
  DateTime: DateTimeField,
  Time: TimeField,
  Calculated: CalculatedField,
  Gallery: GalleryField,
  Table: TableField,
  FileUpload: FileUploadField,
  ImageLabel: ImageLabelField,
  Hyperlink: HyperlinkField,
  Index: IndexField,
  Button: ButtonField,
  TableIndex: TableIndexField,
  ContinuousComments: ContinuousCommentsField,
  Signature: SignatureField,
};

export const AdaptiveField = ({ fieldType, ...otherProps }) => {
  const FieldComponent = fieldComponents[fieldType];

  if (!FieldComponent) {
    return <div>Unknown Field Type: {fieldType}</div>;
  }

  return (
    <FieldComponent
      fieldType={fieldType}
      {...otherProps}
    />
  );
};
